import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import OpportunitiesMobile from "./OpportunitiesMobile";
import OpportunitiesDesktop from "./OpportunitiesDesktop";

function Opportunities({ app, config }) {
	const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

	return isMobile ? (
		<OpportunitiesMobile app={app} config={config} />
	) : (
		<OpportunitiesDesktop app={app} config={config} />
	);
}

Opportunities.defaultProps = {
	app: null,
	config: {},
};

Opportunities.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default Opportunities;
